import { faker } from '@faker-js/faker'

import { ApprovalProcessStatus, PartnerApprovalProcessListItem, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getPartnerApprovalProcessListItem = asBuilder((): PartnerApprovalProcessListItem => {
  return {
    approvalProcessId: faker.number.int(),
    status: faker.helpers.arrayElement([
      ApprovalProcessStatus.PUBLISH_REQUESTED,
      ApprovalProcessStatus.PUBLISH_APPROVED,
      ApprovalProcessStatus.PUBLISH_REJECTED,
    ]),
    title: faker.string.uuid(),
    thumbnail: {
      url: faker.image.url(),
    },
    paymentEnabled: faker.datatype.boolean(),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    approvalReasons: faker.lorem.sentence(),
    createdAtUtc: '2023-07-02T15:00:00.000',
    updatedLastAtUtc: '2023-07-02T15:00:00.000',
    serviceOfferId: faker.number.int(),
  }
})
